import React from 'react';

import {useMainChapters} from 'pageflow-scrolled/frontend';
import {DefaultNavigation} from 'pageflow-scrolled/widgets/defaultNavigation';

import 'pageflow-scrolled/widgets/defaultNavigation.css';

import {Menu} from './Menu';

export function Navigation(props) {
  const chapters = useMainChapters();

  return (
    <DefaultNavigation {...props}
                       Menu={chapters.length > 1 && Menu}
                       omitChapterNavigation={true} />
  );
}
